export default "__VITE_ASSET__d7a093b3__"